export default __webpack_public_path__ + "static/media/ua_mobile.37a9c52a.svg";